// <!--Util-->
import * as angular from "angular";
import { ngHttpUtil } from "webapp/app/shared/services/http.util";
import { ngAuxiliarFactory } from "webapp/app/shared/services/auxiliar";

angular.module('AppModule').factory(ngHttpUtil.name, ngHttpUtil.def);
angular.module('AppModule').factory(ngAuxiliarFactory.name, ngAuxiliarFactory.def);